import { io } from "socket.io-client";
import Cookies from "js-cookie";

let socket = null;

function resolveSocketUrl() {
  const api = (process.env.REACT_APP_BACKEND_BASE_URL || "").trim();
  return api.replace(/\/v3\/?$/i, "").replace(/\/$/, "") || "http://localhost:8100";
}

export function getAdminId() {
  try {
    const token = localStorage.getItem("token") || Cookies.get("naseebiadmin");
    if (!token) return null;
    const cleaned = token.replace(/["',]/g, "");
    const payload = JSON.parse(atob(cleaned.split(".")[1]));
    const rawId = payload?.admin ?? payload?.id ?? payload?.userId ?? payload?.sub;
    const n = Number(rawId);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

function registerSocketHandlers(sock) {
  const onConnect = () => {
    const id = getAdminId();
    if (!id) return;
    sock.emit("userOnline", { userId: id });
    sock.emit("joinSupportStaff", { userId: id });
  };
  sock.on("connect", onConnect);
  if (sock.connected) onConnect();
}

export function getSupportSocket() {
  const adminId = getAdminId();
  if (!socket) {
    socket = io(resolveSocketUrl(), {
      path: "/socket.io",
      transports: ["websocket", "polling"],
      withCredentials: true,
      auth: adminId ? { userId: adminId } : undefined,
      reconnection: true,
    });
    registerSocketHandlers(socket);
  } else if (adminId && socket.connected) {
    socket.emit("userOnline", { userId: adminId });
    socket.emit("joinSupportStaff", { userId: adminId });
  }
  return socket;
}

export function joinSupportTicketRoom(requestId) {
  const adminId = getAdminId();
  getSupportSocket().emit("joinSupportTicket", { requestId, userId: adminId });
}

export function leaveSupportTicketRoom(requestId) {
  getSupportSocket().emit("leaveSupportTicket", { requestId });
}
